<template>
  <v-btn
    v-if="showIt"
    :small="isSmall"
    icon
    :color="color"
    @click="$emit('click')"
  >
    <v-icon :small="isSmall"
      :color="nowCoping?'red':''"
    >{{icon}}</v-icon>
  </v-btn>
</template>

<script>
import supertops from '~api/supertops';
import downloadReportAccess from '~api/download_report_access';
import { MANAGER_TOP } from '@/constants/roles';

export default {
  name: 'DownloadFileButton',
  props: {
    useDownloadReportUsers: {
      type: Boolean,
      default: false,
    },
    additionalAcceptableAccounts: {
      type: Array,
      default() {
        return [];
      },
    },
    color: {
      type: String,
      default: 'grey darken-2',
    },
    icon: {
      type: String,
      default: 'mdi-file-download',
    },
    isSmall: {
      type: Boolean,
      default: true,
    },
    nowCoping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      forSupertops: true,
    };
  },
  computed: {
    showIt() {

      if (this.forSupertops && supertops.includes(this.account.id)) {
        return true;
      }

      if (this.useDownloadReportUsers && downloadReportAccess.includes(this.account.phone)) {
        return true;
      }

      if (this.additionalAcceptableAccounts.length > 0 && this.additionalAcceptableAccounts.includes(this.account.id)) {
        return true;
      }

      return false;
    },
    account() {
      return this.$store.getters['account/account'];
    },
  },

};
</script>

<style scoped>

</style>
